'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TranslateGender = function () {
  function TranslateGender() {
    _classCallCheck(this, TranslateGender);
  }

  _createClass(TranslateGender, null, [{
    key: 'Translate',
    value: function Translate(gender, lang) {
      switch (lang) {
        case 'en':
          switch (gender) {
            case 'männlich':
              {
                return 'male';
              }
            case 'male':
              {
                return 'male';
              }
            case 'weiblich':
              {
                return 'female';
              }
            case 'female':
              {
                return 'female';
              }
            case 'divers':
              {
                return 'divers';
              }
            default:
              return '';
          }

        /*if (gender === 'männlich' || gender === 'male'){
          return 'male';
        } else {
          return 'female';
        }*/
        case 'de':
          switch (gender) {
            case 'männlich':
              {
                return 'männlich';
              }
            case 'male':
              {
                return 'männlich';
              }
            case 'weiblich':
              {
                return 'weiblich';
              }
            case 'female':
              {
                return 'weiblich';
              }
            case 'divers':
              {
                return 'divers';
              }
            default:
              return '';
          }

        /*if (gender === 'männlich'|| gender === 'male'){
          return 'männlich';
        } else {
          return 'weiblich';
        }*/
        default:
          break;
      }
    }
  }]);

  return TranslateGender;
}();

exports.default = TranslateGender;